/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.settlement.controllers', [
    'ui.router',
    'acme.common.service.api'
])

.controller('SettlementController', ['$scope', '$state', 'ApiService', function($scope, $state, ApiService) {

    $scope.results = [];

    $scope.settlement = {

        createDate: new Date(),

        paging: {
            pageSize: 25,
            currentPage: 1,
            totalItems: 0,
            totalPages: 1,

            next: function() {
                if ( this.currentPage < this.totalPages ) {
                    this.currentPage++;
                    $scope.settlement.load(this.currentPage);
                }
            },

            previous: function() {
                if ( this.currentPage > 1 ) {
                    this.currentPage--;
                    $scope.settlement.load(this.currentPage);
                }
            }
        },

        init: function() {

            this.load();

            $scope.$emit('Application::contentTitleChange', {
                title: "Settlement"
            });
        },

        loadSettlement: function(id) {
            $state.go('application.settlement.detail', { id: id });
        },

        load: function() {
            ApiService.settlements.list(this.paging.currentPage).then(this.success.list, this.error.list);
        },

        create: function() {
            ApiService.settlements.create($scope.settlement.formatDate()).then(this.success.create, this.error.create);
        },

        formatDate: function() {
            var d = $scope.settlement.createDate;
            return  d.getFullYear() + '-' + ('0' + (d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
        },

        success: {
            list: function(response) {
                $scope.results = response.data.payload;
                $scope.settlement.paging.totalPages = $scope.results.totalPages;
            },

            create: function(response) {
                // refresh the list of settlements
                $scope.settlement.load();
            }
        },

        error: {
            list: function(response) {

            },

            create: function(response) {

            }
        }
    };

    $scope.settlement.init();

}]);